<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("_EDIT_GROUP.INFO") }}</h4>
    </div>

    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>

    <div class="grid-body p-3 pb-0 border-top-unset" v-if="!isLoading">
      <v-tabs v-model="currentTabIndex" background-color="transparent" class="pl-0">
        <v-tab v-for="tabItem in tabs" :key="tabItem.index" :disabled="tabItem.disabled">{{ tabItem.label }}</v-tab>
      </v-tabs>
      <div v-if="currentTabIndex === 0" class="mt-3">
        <v-form ref="formGroup" lazy-validation>
          <div class="mt-3">
            <div class="card-item-content pt-0">
              <v-row>
                <v-col cols="12">
                  <label class="label-input">{{
                    $t("_EDIT_GROUP.GROUP_NAME") + $t("REQUIRED")
                  }}</label>
                  <v-text-field dense outlined maxlength="30" :rules="[rules.required]" v-model="data.groupName">
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <label class="label-input">{{
                    $t("_EDIT_GROUP.GROUP_CODE") + $t("REQUIRED")
                  }}</label>
                  <v-text-field dense outlined maxlength="30" :disabled="isEdit == true" :rules="[rules.required]"
                    v-model="data.groupCode"> </v-text-field>
                </v-col>

                <v-col cols="12">
                  <label class="label-input">{{
                    $t("_EDIT_GROUP.GROUP_ROLE") + $t("REQUIRED")
                  }}</label>
                  <v-text-field dense outlined maxlength="50" :rules="[rules.required]" v-model="data.role">
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <label class="label-input">{{
                    $t("_EDIT_GROUP.DESCRIPTION")
                  }}</label>
                  <input-textarea :rows="3" :model.sync="data.description" :error.sync="error.description.error"
                    maxlength="300" />
                </v-col>

                <v-col cols="12">
                  <v-checkbox v-model="data.active" color="#173d8f" :label="$t('_EDIT_GROUP.STATUS')"
                    class="mt-0"></v-checkbox>
                </v-col>

                <v-col cols="6" v-if="!isEdit || (data.parentId && isEdit)">
                  <label class="label-input">{{ $t("_EDIT_GROUP.PARENT_GROUP") }} *</label>
                  <v-select outlined dense :item-text="text" :item-value="value" :items="listGroup"
                    v-model="data.selectedUserGroup" :rules="[rules.required]" v-if="!isEdit"></v-select>
                  <input-text v-if="isEdit == true" disabled
                    :model.sync="listGroup.find(e => data.selectedUserGroup === e.value).text" />
                </v-col>
                <v-col cols="6">
                  <label class="label-input">{{ $t("_EDIT_GROUP.TYPE") }} *</label>
                  <v-select outlined dense :item-text="text" :item-value="value" :items="listType"
                    v-model="data.selectedType" v-if="!isEdit"></v-select>
                  <input-text v-if="isEdit == true" disabled
                    :model.sync="listType.find(e => data.selectedType === e.value).text" />
                </v-col>
                <v-col cols="12" class="text-right">
                  <v-btn depressed @click="back" class="mr-3">{{
                    $t("BACK")
                  }}</v-btn>
                  <v-btn color="primary" @click="validateUserGroup" class="pl-10 pr-10">{{ $t("SAVE") }}</v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-form>
      </div>
      <div v-if="currentTabIndex === 1" class="mt-3">
        <table class="role-container">
          <thead>
            <tr>
              <th class="column-1 text-center">{{ $t("_EDIT_USER.NO") }}</th>
              <th class="column-2">{{ $t("_EDIT_USER.FUNCTION_CODE") }}</th>
              <th>{{ $t("_EDIT_USER.FUNCTION_NAME") }}</th>
              <th class="column-4 text-center">
                {{ $t("_EDIT_USER.ACTION") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Level 1 -->
            <template v-for="(role, index) in roles">
              <tr :key="role.id">
                <td class="level-1 text-center">{{ index + 1 }}</td>
                <td class="level-1">
                  <v-icon v-if="role.child && role.child.length > 0 && role.showed" @click="
                    role.showed = false;
                  _forceUpdate();
                  " class="cell-icon">arrow_drop_up</v-icon>
                  <v-icon v-if="role.child && role.child.length > 0 && !role.showed" @click="
                    role.showed = true;
                  _forceUpdate();
                  " class="cell-icon">arrow_drop_down</v-icon>
                  <strong>{{ role.fnCode }}</strong>
                </td>
                <td class="level-1">{{ $t("_ROLES." + role.fnName) }}</td>
                <td class="level-1 text-center">
                  <v-checkbox :disabled="role.disabled" v-model="role.checked" @change="toggleAll(role)" color="#173d8f"
                    class="main-checkbox-no-text justify-center mt-0 pt-0" />
                </td>
              </tr>
              <template v-if="role.showed">
                <!-- Level 2 -->
                <template v-for="roleChild in role.child">
                  <tr :key="roleChild.id">
                    <td class="level-2 text-center"></td>
                    <td class="level-2 child">
                      <v-icon v-if="roleChild.child &&
                        roleChild.child.length > 0 &&
                        roleChild.showed
                        " @click="
    roleChild.showed = false;
  _forceUpdate();
  " class="cell-icon">arrow_drop_up</v-icon>
                      <v-icon v-if="roleChild.child &&
                        roleChild.child.length > 0 &&
                        !roleChild.showed
                        " @click="
    roleChild.showed = true;
  _forceUpdate();
  " class="cell-icon">arrow_drop_down</v-icon>
                      <strong>{{ roleChild.fnCode }}</strong>
                    </td>
                    <td class="level-2 child">
                      {{ $t("_ROLES." + roleChild.fnName) }}
                    </td>
                    <td class="level-2 text-center">
                      <v-checkbox :disabled="roleChild.disabled" v-model="roleChild.checked"
                        @change="toggleAll(roleChild, [role])" color="#173d8f"
                        class="main-checkbox-no-text justify-center mt-0 pt-0" />
                    </td>
                  </tr>
                  <template v-if="roleChild.showed">
                    <!-- Level 3 -->
                    <template v-for="roleGrandChild in roleChild.child">
                      <tr :key="roleGrandChild.id">
                        <td class="level-3 text-center"></td>
                        <td class="level-3 child">
                          <v-icon v-if="roleGrandChild.child &&
                            roleGrandChild.child.length > 0 &&
                            roleGrandChild.showed
                            " @click="
    roleGrandChild.showed = false;
  _forceUpdate();
  " class="cell-icon">arrow_drop_up</v-icon>
                          <v-icon v-if="roleGrandChild.child &&
                            roleGrandChild.child.length > 0 &&
                            !roleGrandChild.showed
                            " @click="
    roleGrandChild.showed = true;
  _forceUpdate();
  " class="cell-icon">arrow_drop_down</v-icon>
                          <strong>{{ roleGrandChild.fnCode }}</strong>
                        </td>
                        <td class="level-3 child">
                          {{ $t("_ROLES." + roleGrandChild.fnName) }}
                        </td>
                        <td class="level-3 text-center">
                          <v-checkbox :disabled="roleGrandChild.disabled" v-model="roleGrandChild.checked" @change="
                            toggleAll(roleGrandChild, [roleChild, role])
                            " color="#173d8f" class="main-checkbox-no-text justify-center mt-0 pt-0" />
                        </td>
                      </tr>
                      <template v-if="roleGrandChild.showed">
                        <!-- Level 4 -->
                        <template v-for="greatGrandChild in roleGrandChild.child">
                          <tr :key="greatGrandChild.id">
                            <td class="level-4 text-center"></td>
                            <td class="level-4 child">
                              <v-icon v-if="greatGrandChild.child &&
                                greatGrandChild.child.length > 0 &&
                                greatGrandChild.showed
                                " @click="
    roleGrandChild.showed = false;
  _forceUpdate();
  " class="cell-icon">arrow_drop_up</v-icon>
                              <v-icon v-if="greatGrandChild.child &&
                                greatGrandChild.child.length > 0 &&
                                !greatGrandChild.showed
                                " @click="
    greatGrandChild.showed = true;
  _forceUpdate();
  " class="cell-icon">arrow_drop_down</v-icon>
                              <strong>{{ greatGrandChild.fnCode }}</strong>
                            </td>
                            <td class="level-4 child">
                              {{ $t("_ROLES." + greatGrandChild.fnName) }}
                            </td>
                            <td class="level-4 text-center">
                              <v-checkbox :disabled="greatGrandChild.disabled" v-model="greatGrandChild.checked" @change="
                                toggleAll(greatGrandChild, [
                                  roleGrandChild,
                                  roleChild,
                                  role
                                ])
                                " color="#173d8f" class="main-checkbox-no-text justify-center mt-0 pt-0" />
                            </td>
                          </tr>
                        </template>
                      </template>
                    </template>
                  </template>
                </template>
              </template>
            </template>
          </tbody>
        </table>
        <div class="card-item-content">
          <v-row>
            <v-col class="text-right">
              <v-btn depressed @click="back" class="mr-3">{{
                $t("BACK")
              }}</v-btn>
              <v-btn color="primary" @click="updateGroupRole" class="pl-10 pr-10">{{ $t("SAVE") }}</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main-tab-wrapper {
  margin-left: 20px;
  padding-left: 0;
}

.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.column-1 {
  width: 5rem;
}

.column-2 {
  width: 15rem;
}

.column-4 {
  width: 7rem;
}
</style>

<script>
import Input from "@/components/Utils/Input.vue";
import Textarea from "@/components/Utils/Textarea.vue";
import { getMgError } from "@/_helpers/config.js";
import { _validateFormI18n, _alert } from "@/_helpers/function.js";
import { service } from "@/_services/Account/ManageUser/manage-user.service.js";

import VueSingleSelect from "vue-single-select";

export default {
  components: {
    "input-text": Input,
    "input-textarea": Textarea,
    VueSingleSelect
  },
  data() {
    return {
      tabs: [
        { index: 0, disabled: false, label: this.$t("_LIST_GROUP.LIST_GROUP") },
        { index: 1, disabled: false, label: this.$t("_EDIT_USER.ROLE") }
      ],
      currentTabIndex: 0,
      rules: {
        required: value =>
          (!!value && value.length > 0) || this.$t("_REGISTER.REQUIRED_FIELD")
      },
      isLoading: false,
      isEdit: false,
      data: {
        active: true,
        groupName: "",
        groupCode: "",
        userGroupId: "",
        selectedType: 0,
        selectedUserGroup: null
      },
      listType: [
        { text: "ADMINISTRATION", value: 0 },
        { text: "HOTEL", value: 1 },
        { text: "PARTNER", value: 2 }
      ],
      error: getMgError(),
      roles: [],
      listGroup: [],
      currentGroupRole: []
    };
  },
  async mounted() { },
  created() {
    this.initialize();
  },
  methods: {
    // Run when start
    initialize() {
      let requests = [];
      requests.push(service.getAllActiveUserGroup({ name: "" }));
      if (this.$route.params && this.$route.params.id) {
        this.isEdit = true;
        requests.push(this.getUserGroupDetail(this.$route.params.id));
      } else {
        this.tabs.splice(1, 1);
      }
      requests.push(this.getAllRole());
      this.isLoading = true;
      Promise.all(requests)
        .then(response => {
          this.listGroup = response[0].data.map(e =>
            Object.assign({}, {
              text: e.groupName,
              value: e.id
            }
            ));
          if (response[1]) {
            let res = response[1];
            if (res.responseCode === 0) {
              this.data = res.data;
              this.data.selectedType = res.data.type;
              this.data.selectedUserGroup = this.listGroup.find(
                group => group.value == this.data.parentId
              ).value;
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },
    async getAllRole() {
      return await service.getAllFunction().then(res => {
        if (res.responseCode === 0) {
          this.convertRole(res.data);
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    convertRole(roles) {
      this.roles = [];
      // Filter all root roles
      const rootRoles = roles
        .filter(role => role.parentId === null)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      this.roles = this.roles.concat(rootRoles);
      // For each root role, find all child role, add to child list, recursive until no more role found
      for (let role of this.roles) {
        role.child = this.filterChildRoles(role.id, roles);
      }
    },
    filterChildRoles(parentId, roles) {
      // End recursive condition
      if (!parentId || parentId === 0 || !roles || roles.length === 0) {
        return [];
      }
      let filterRoles = roles
        .filter(role => role.parentId === parentId)
        .map(role =>
          Object.assign({}, role, {
            checked: false,
            showed: false
          })
        );
      for (let role of filterRoles) {
        // recursive recursive recursive ...
        role.child = this.filterChildRoles(role.id, roles);
      }
      return filterRoles;
    },
    toggleAll(item, parents) {
      if (item.child) {
        for (const child of item.child) {
          this.toggleChild(item, child);
        }
      }
      // if (parents) {
      //   for (const parent of parents) {
      //     // this.toggleParent(parent);
      //   }
      // }
      this._forceUpdate();
    },
    toggleParent(parent) {
      if (parent.child) {
        parent.checked = parent.child
          .map(x => x.checked)
          .reduce((a, b) => a || b, false);
      }
    },
    toggleChild(parent, child) {
      child.checked = parent.checked;
      if (child.child) {
        for (const grandChild of child.child) {
          this.toggleChild(child, grandChild);
        }
      }
    },
    // Get checked role
    getCheckedRoles(roleList, role) {
      roleList.push(role);
      if (role.child) {
        for (let child of role.child) {
          this.getCheckedRoles(roleList, child);
        }
      }
    },
    updateGroupRole() {
      let flatRole = [];
      for (let role of this.roles) {
        this.getCheckedRoles(flatRole, role);
      }
      const checkedRole = flatRole
        .filter(role => role.checked)
        .map(role => role.id);
      let temp = {
        id: this.data.id,
        funcId: checkedRole
      };
      this.isLoading = true;
      service
        .updateUserGroupFunction(temp)
        .then(res => {
          if (res.responseCode === 0 && !this.isEdit) {
            this.back();
          }
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    // Go back
    back() {
      this.$router.back();
    },
    // Async - Get user group detail
    async getUserGroupDetail(id) {
      return await service.getUserGroupDetail(id);
    },
    // Validate user group
    validateUserGroup() {
      let { isValid, error } = _validateFormI18n(this.data, this.error);
      this.error = error;
      let isValidFrom = this.$refs.formGroup.validate();
      if (!isValidFrom) return false;
      if (!isValid) return false;
      if (!this.isEdit) {
        this.createUserGroup();
      } else {
        // Update
        this.updateUserGroup();
      }
    },
    // Create user group
    async createUserGroup() {
      let temp = {
        groupName: this.data.groupName,
        description: this.data.description,
        active: this.data.active,
        groupCode: this.data.groupCode,
        role: this.data.role,
        type: this.data.selectedType,
        parentId: this.data.selectedUserGroup
      };
      this.isLoading = true;
      await service
        .createUserGroup(temp)
        .then(res => {
          if (res.responseCode === 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
            // Set group id
            this.data.id = res.data;
            this.tabs.push({
              index: 1,
              disabled: false,
              label: this.$t("_EDIT_USER.ROLE")
            });
            this.currentTabIndex = this.tabs[1].index;
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Update user group
    updateUserGroup() {
      let temp = {
        id: this.data.id,
        groupName: this.data.groupName,
        description: this.data.description,
        active: this.data.active,
        groupCode: this.data.groupCode,
        role: this.data.role,
        type: this.data.selectedType,
        parentId: this.data.parentId ? this.data.selectedUserGroup : null
      };
      this.isLoading = true;
      service
        .updateUserGroup(temp)
        .then(res => {
          if (res) {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    _forceUpdate() {
      this.$forceUpdate();
    },
    // Get all user group
    async searchGroupByName(name) {
      return await service.getAllActiveUserGroup({ name: name }).then(res => {
        if (res.responseCode === 0) {
          this.listGroup = res.data;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    remoteFilterUserGroup(event) {
      this.searchGroupByName(event.target.value);
    }

  }
};
</script>
